import { useListings } from "@/hooks/useListings";
import { Board } from "@/components/Board";
import { useUI } from "@/store/ui";

export function App() {
  const { data, isLoading, error } = useListings();
  const { hideRejected, toggleHideRejected } = useUI();

  return (
    <div className="flex flex-col h-full">
      <header className="flex items-center justify-between px-6 py-3 bg-ink-900 text-ink-100 shadow-sm">
        <div className="flex items-baseline gap-3">
          <h1 className="text-lg font-semibold tracking-tight">flathunt</h1>
          <span className="text-xs text-ink-400">
            {data ? `${data.length} listings` : "…"}
          </span>
        </div>
        <label className="flex items-center gap-2 text-sm text-ink-300 select-none cursor-pointer">
          <input
            type="checkbox"
            checked={hideRejected}
            onChange={toggleHideRejected}
            className="accent-ink-500"
          />
          Hide rejected
        </label>
      </header>

      <main className="flex-1 min-h-0 overflow-hidden">
        {isLoading && (
          <div className="p-6 text-ink-500 text-sm">Loading…</div>
        )}
        {error && (
          <div className="p-6 text-red-700 text-sm">
            Failed to load: {(error as Error).message}
          </div>
        )}
        {data && <Board listings={data} hideRejected={hideRejected} />}
      </main>
    </div>
  );
}
